import { Loader, TextInput } from '@common/ui'
import React from 'react'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import useEntityById from '../../io/useEntityById'
import Field = com.eidu.entity.field.Field
import entityIdFromStringOrNull = com.eidu.entity.entityIdFromStringOrNull

export type EntityFormReferenceDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormReferenceDisplay = ({ field, fieldValue }: EntityFormReferenceDisplayProps) => {
  const selectedId = fieldValue?.value?.let((it) => entityIdFromStringOrNull(it)) ?? undefined
  const { entity: selected, loading } = useEntityById(selectedId)
  const label = selected ? selected.primaryLabelText : ''
  const displayLoading = loading || fieldValue === undefined
  return (
    <TextInput
      disabled
      required={field.required}
      label={field.name}
      value={label}
      placeholder={displayLoading ? ' ' : undefined}
      rightSection={loading && <Loader size="xs" />}
    />
  )
}

export default EntityFormReferenceDisplay
